module.exports = require("lodash/set");


//////////////////
// WEBPACK FOOTER
// external "lodash/set"
// module id = 6
// module chunks = 0